<div class="row wrapper border-bottom white-bg page-heading info-projeto">
  <div class="col-lg-10 title-projeto">
    <h2>Processo</h2>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="menu-mobile" #menuMobile>
          <ul class="">
            <ng-container *ngFor="let item of menu">
              <li *ngIf="item?.active && isActive(item.rota)">
                <a [class.active]="isActive(item.rota)" [routerLink]="[pathRoute, item.rota]">
                  {{item.label}}
                </a>
              </li>
            </ng-container>
          </ul>
          <button type="button" (click)="openBottomSheet()">
            <img src="assets/images/svgs/arrow-down-up.svg" alt="Menu">
          </button>
        </div>
        <div class="tabs-container menu" #menuDesktop>
          <ul class="nav nav-tabs" role="tablist">
            <ng-container *ngFor="let item of menu">
              <li *ngIf="item?.active">
                <a [class.active]="isActive(item.rota)" [routerLink]="[pathRoute, item.rota]">
                  {{item.label}}
                </a>
              </li>
            </ng-container>
          </ul>
        </div>
        <div class="ibox-content box-content box-content-layout">
          <router-outlet></router-outlet>
          <app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
        </div>
      </div>
    </div>
  </div>
</div>